<div class="container-xl pb-lg-8 verify-container">
  <h1 class="text-navy my-6">Verify your identity to view your payment details</h1>

  <div class="row">
    <div class="col-sm-12 col-md-10 mb-4">
      <ui-alert
        [alertTextTemplate]="alertTextTemplate"
        [alertStatus]="alertStatus"
        [fullWidth]="false"
        [hidden]="(showAlert$ | async) === false"
      >
      </ui-alert>

      <ng-template #alertTextTemplate>
        <div class="text" [innerHTML]="errorMsg"></div>
      </ng-template>
    </div>
  </div>

  <form [formGroup]="patientForm" (ngSubmit)="onSubmit()" *ngIf="!linkInvalid">
    <div class="d-flex flex-column flex-lg-row gap-6">
      <div class="d-flex flex-column flex-md-row gap-6">
        <div class="verify-field-dob">
          <label for="dateOfBirth" class="form-label">Date of Birth</label>
          <input
            type="text"
            class="form-control"
            formControlName="dateOfBirth"
            id="dateOfBirth"
            placeholder="MM/DD/YYYY"
            matInput
            mask="00/00/0000"
            [showMaskTyped]="false"
            autocomplete="off"
            [class.is-invalid]="
              patientForm.controls.dateOfBirth.invalid &&
              (patientForm.controls.dateOfBirth.dirty || patientForm.controls.dateOfBirth.touched)
            "
          />
          <ui-form-field-msg id="patientDobError" [validationMessages]="validationMessages.dateOfBirth" controlName="dateOfBirth">
          </ui-form-field-msg>
        </div>

        <div class="verify-field-zip">
          <label for="zipCode" class="form-label">ZIP Code</label>
          <input
            type="text"
            class="form-control"
            formControlName="zipCode"
            maxlength="5"
            id="zipCode"
            autocomplete="off"
            [class.is-invalid]="
              patientForm.controls.zipCode.invalid && (patientForm.controls.zipCode.dirty || patientForm.controls.zipCode.touched)
            "
          />
          <ui-form-field-msg id="patientZipError" [validationMessages]="validationMessages.zipCode" controlName="zipCode">
          </ui-form-field-msg>
        </div>
      </div>

      <div class="verify-field-button">
        <div class="button-label-spacer"></div>
        <ui-button
          [buttonText]="'View Payment Details'"
          [buttonType]="'submit'"
          [buttonDisabled]="btnSubmitSpin"
          [inProgress]="btnSubmitSpin"
          [iconRight]="'open_in_new'"
          [minWidth]="128"
          [addClass]="'verify-button mobile-full-width'"
        >
        </ui-button>
      </div>
    </div>
  </form>
</div>
